import 'jquery';
import { de, en, es, fr, it, sv } from './i18n';
import './picker.date.custom';
import { classic, modal } from './theme';

/**
 * Init datepicker fields.
 */
export default function initDatepickers() {

  /**
   * English datepickers.
   */
  if($('.datepicker-en').length > 0) {
    $('.datepicker-en').pickadate(Object.assign({}, en, classic));
  }

  /**
   * Spanish datepickers.
   */
  if($('.datepicker-es').length > 0) {
    $('.datepicker-es').pickadate(Object.assign({}, es, classic));
  }

  /**
   * Italian datepickers.
   */
  if($('.datepicker-it').length > 0) {
    $('.datepicker-it').pickadate(Object.assign({}, it, classic));
  }

  /**
   * French datepickers.
   */
  if($('.datepicker-fr').length > 0) {
    $('.datepicker-fr').pickadate(Object.assign({}, fr, classic));
  }

  /**
   * Swedish datepickers.
   */
  if($('.datepicker-sv').length > 0) {
    $('.datepicker-sv').pickadate(Object.assign({}, sv, classic));
  }

  /**
   * German datepickers.
   */
  if($('.datepicker-de').length > 0) {
    if($('.datepicker-de').attr('data-theme') === 'modal') {
      $('.datepicker-de').pickadate(Object.assign({}, de, modal));
    } else {
      $('.datepicker-de').pickadate(Object.assign({}, de, classic));
    }
  }

}
